import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import { TrustPilotLogo } from 'components/Common/TrustIndicators/TrustPilotLogo'
import AtolLogoIcon from 'LuxKit/Icons/AtolLogoIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

// The logo doesn't quite have a nice centre line, we need to nudge it up to make it line up
const NudgedTrustPilotLogo = styled(TrustPilotLogo)`
  transform: translateY(-3px);
`

export type NavUspType = 'google' | 'trustpilot' | 'atol'

interface Props {
  type: NavUspType
}

function NavBarUSP(props: Props) {
  const { type } = props
  const intl = useIntl()

  const atolLabel = intl.formatMessage({
    id: 'twyvRmnnslETd3sTskc7',
    defaultMessage: 'ATOL protected',
    description: 'Trust indicator showing ATOL financial protection in navigation bar',
  })
  const googleRating = '4.7/5'
  const trustpilotRating = '4.8/5'

  switch (type) {
    case 'atol':
      return <BodyTextBlock
        variant="small"
        startIcon={<AtolLogoIcon colour="normal-contrast" />}
        colour="light-foreground-alt"
      >
        {atolLabel}
      </BodyTextBlock>
    case 'google':
      return <Group direction="horizontal" gap={4} verticalAlign="center">
        <GoogleLongLogo height={rem(14)} />
        <BodyText variant="small">{googleRating}</BodyText>
      </Group>
    case 'trustpilot':
      return <Group direction="horizontal" gap={4} verticalAlign="center">
        <NudgedTrustPilotLogo height={rem(16)} />
        <BodyText as="span" variant="small">{trustpilotRating}</BodyText>
      </Group>
    default:
      return null
  }
}

export default memo(NavBarUSP)
